import React from 'react'; 
import './App.css';
import { Provider } from 'react-redux';
import { store } from './Redux/Store';
import RoutesComponent from "./Routes";

function App() {
  return (
    <Provider store={store}> 
      <RoutesComponent />
    </Provider>
  );
}

export default App;
